// extracted by mini-css-extract-plugin
module.exports = {"baseSection":"index-module--base-section--1O7oM"};